import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const ContentBox = styled(Box)`
	border: 1px solid #002581;
	background-color: #00001f;
	padding: 12px 16px;
`;

const DottedGutter = styled(Box)`
	margin: 12px 0;
	border-top: 1px dashed #6a7cb0;
	opacity: 0.7;
`;

const AmountLabel = styled(Typography)`
	font-size: 22px;
	font-weight: 700;
`;

const AssetLabel = styled(Typography)`
	font-size: 14px;
`;

const Temp = styled('div')`
	min-height: 26px;
`;

const YourPnL: React.ComponentType = () => {
	return (
		<ContentBox>
			<Box display="flex" alignItems="center">
				<Typography color="#CCCCD1" fontSize="14px" fontWeight="700">
					Your iVCRED points
				</Typography>
				{/*<Box sx={{ width: 8 }} />
				<Typography color="#80808E" fontSize="12px" fontWeight="700">
					24 h
				</Typography>*/}
			</Box>

			<Box height={22} />

			<Box display="flex" justifyContent="space-between">
				<Box display="flex" alignItems="baseline">
					<Temp />
					{/*<AmountLabel>0</AmountLabel>
					<Box width={4} />
					<AssetLabel>AVAX</AssetLabel>*/}
				</Box>

				{/*<Box
					border="2px solid #2BE8AA"
					display="flex"
					alignItems="center"
					padding="2px"
				>
					<Typography color="#2BE8AA" fontWeight="bold">
						0.00%
					</Typography>
				</Box>*/}
			</Box>

			<DottedGutter />

			<Box display="flex" justifyContent="space-between">
				<Box display="flex" alignItems="baseline">
					<Temp />
					{/*<AmountLabel>0</AmountLabel>
					<Box width={4} />
					<AssetLabel>USDC</AssetLabel>*/}
				</Box>

				{/*<Box
					border="2px solid #2BE8AA"
					display="flex"
					alignItems="center"
					padding="2px"
				>
					<Typography color="#2BE8AA" fontWeight="bold">
						0.00%
					</Typography>
				</Box>*/}
			</Box>

			<DottedGutter />

			<Box display="flex" justifyContent="space-between">
				<Box display="flex" alignItems="baseline">
					<Temp />
					{/*<AmountLabel>0</AmountLabel>
					<Box width={4} />
					<AssetLabel>BTC.B</AssetLabel>*/}
				</Box>

				{/*<Box
					border="2px solid #2BE8AA"
					display="flex"
					alignItems="center"
					padding="2px"
				>
					<Typography color="#2BE8AA" fontWeight="bold">
						0.00%
					</Typography>
				</Box>*/}
			</Box>
		</ContentBox>
	);
};

export { YourPnL };
